import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import styles from "./Login.module.scss";
import { API_ENDPOINTS } from "../config/api";
import { useAuth } from "../context/AuthContext";
import logo from "../images/logo.png";

function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg("");
    setIsLoading(true);
    
    try {
      const response = await fetch(API_ENDPOINTS.AUTH.LOGIN, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });
      
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.error || "Login failed");
      }
      
      // Save token and user data
      login(data.token, data.user);

      // Navigate to requested page if present
      const redirectTarget = searchParams.get("redirect");
      const safeRedirect = redirectTarget && redirectTarget.startsWith("/")
        ? redirectTarget
        : "/dashboard/overview";

      navigate(safeRedirect, { replace: true });
    } catch (err) {
      console.error(err);
      setErrorMsg(err.message || "Échec de la connexion. Veuillez réessayer.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.loginContainer}>
      <div className={styles.loginBox}>
        <img src={logo} alt="Palais Royal" className={styles.logo} />
        <p className={styles.subtitle}>Administration</p>
        <form onSubmit={handleSubmit}>
          {errorMsg && <p className={styles.error}>{errorMsg}</p>}
          <div className={styles.inputGroup}>
            <label>Nom d'utilisateur</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div className={styles.inputGroup}>
            <label>Mot de passe</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button 
            type="submit" 
            className={styles.loginBtn}
            disabled={isLoading}
          >
            {isLoading ? "Connexion..." : "Se connecter"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
